import {
    ON_CUSTODY_CENTERS_LIST,
    ON_CUSTODY_CENTER_ADD,
    ON_CUSTODY_CENTER_UPDATE,
    SCC_STOCKBALANCES_DATA,
    SCC_STOCKBALANCES_DATA_INIT,
    SCC_STOCK_HOLDING_DATA
} from '../constants/ActionTypes';

const INIT_STATE = {
    custodyCentersList: [],
    custodyCenterAdded: {},
    custodyCenterUpdated: {},
    stockBalances: [],
    stockHolding: null,
    show: false
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ON_CUSTODY_CENTERS_LIST: {
            return { ...state, custodyCentersList: action.payload };
        }
        case ON_CUSTODY_CENTER_ADD: {
            return { ...state, custodyCenterAdded: action.payload };
        }
        case ON_CUSTODY_CENTER_UPDATE: {
            return { ...state, custodyCenterUpdated: action.payload };
        }
        case SCC_STOCKBALANCES_DATA: {
            return { ...state, show: true, stockBalances: action.payload };
        }
        case SCC_STOCKBALANCES_DATA_INIT: {
            return { ...state, show: false, stockBalances: [] };
        }
        case SCC_STOCK_HOLDING_DATA: {
            return { ...state, stockHolding: action.payload };
        }

        default:
            return state;
    }
}